export default __webpack_public_path__ + "static/media/landing_teams_sharing_2.06ecf827.jpg";